<script>
import VueApexCharts from "vue-apexcharts";
import { setupHeatmapSeries, roundOff2 } from "@/utils.js";
import { getAnalytics, getAnalyticsAvg } from "@/api/analytics";
const metrics = ["sales", "average_check", "frequency", "recency", "traffic"];
const baselines = [
  "self",
  "compset",
  "diff",
  "segment",
  "diff",
  "industry",
  "diff",
];
const baselines2 = [
  "Self",
  "Compset",
  "Diff",
  "Segment",
  "Diff",
  "Industry",
  "Diff",
];
export default {
  name: "kpi-heatmap-location",
  props: ["item", "dtpicker", "selectedYearOver"],
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: "heatmap",
        },
        plotOptions: {
          heatmap: {
            radius: 10,
            enableShades: false,
            colorScale: {
              ranges: [
                {
                  from: 0,
                  to: 0,
                  color: "#cccccc",
                },
                {
                  from: 0.1,
                  to: 0.9,
                  color: "#b2d8b2",
                },
                {
                  from: 1,
                  to: 10.9,
                  color: "#b2d8b2",
                },
                {
                  from: 11,
                  to: 20.9,
                  color: "#99cc99",
                },
                {
                  from: 21,
                  to: 30.9,
                  color: "#7fbf7f",
                },
                {
                  from: 31,
                  to: 40.9,
                  color: "#66b266",
                },
                {
                  from: 41,
                  to: 50.9,
                  color: "#4ca64c",
                },
                {
                  from: 51,
                  to: 60.9,
                  color: "#329932",
                },
                {
                  from: 61,
                  to: 70.9,
                  color: "#198c19",
                },
                {
                  from: 71,
                  to: 80.9,
                  color: "#008000",
                },
                {
                  from: 81,
                  to: 90.9,
                  color: "#007300",
                },
                {
                  from: 91,
                  to: 100.9,
                  color: "#006600",
                },
                {
                  from: 101,
                  to: 110.9,
                  color: "#005900",
                },
                {
                  from: 111,
                  to: 120.9,
                  color: "#004c00",
                },
                {
                  from: 121,
                  to: 150.9,
                  color: "#004000",
                },
                {
                  from: 151,
                  to: 200.9,
                  color: "#003300",
                },
                {
                  from: 201,
                  to: 300.9,
                  color: "#002600",
                },
                {
                  from: 301,
                  to: 10000,
                  color: "#001900",
                },
                {
                  from: -0.9,
                  to: -0.1,
                  color: "#ffb2b2",
                },
                {
                  from: -10.9,
                  to: -1,
                  color: "#ffb2b2",
                },
                {
                  from: -20.9,
                  to: -11,
                  color: "#ff9999",
                },
                {
                  from: -30.9,
                  to: -21,
                  color: "#ff7f7f",
                },
                {
                  from: -40.9,
                  to: -31,
                  color: "#ff6666",
                },
                {
                  from: -50.9,
                  to: -41,
                  color: "#ff4c4c",
                },
                {
                  from: -60.9,
                  to: -51,
                  color: "#ff3232",
                },
                {
                  from: -70.9,
                  to: -61,
                  color: "#ff1919",
                },
                {
                  from: -80.9,
                  to: -71,
                  color: "#ff0000",
                },
                {
                  from: -90.9,
                  to: -80,
                  color: "#e50000",
                },
                {
                  from: -100.9,
                  to: -91,
                  color: "#cc0000",
                },
                {
                  from: -110.9,
                  to: -101,
                  color: "#b20000",
                },
                {
                  from: -120.9,
                  to: -111,
                  color: "#990000",
                },
                {
                  from: -10000,
                  to: -121,
                  color: "#7f0000",
                },
              ],
            },
          },
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return `${val}%`;
          },
        },
        xaxis: {
          type: "category",
          position: "top",
          categories: baselines2,
        },
        yaxis: {
          show: true,
          labels: {
            show: true,
            formatter: function(val) {
              function titleCase(str) {
                var splitStr = str.toLowerCase().split("_");
                for (var i = 0; i < splitStr.length; i++) {
                  splitStr[i] =
                    splitStr[i].charAt(0).toUpperCase() +
                    splitStr[i].substring(1);
                }
                return splitStr.join(" ");
              }
              if (val) {
                if (typeof val === "string") {
                  return titleCase(val);
                }
              }
            },
          },
        },
        tooltip: {
          custom: function({series, seriesIndex, dataPointIndex, w}) {
            return '<div class="arrow_box">' +
              '<span>' + series[seriesIndex][dataPointIndex] + '</span>' +
              '</div>'
          }
        }
      },
      loading: true,
      result: [],
    };
  },

  async mounted() {
    // console.log("item", this.item);
    // console.log("dtpicker", this.dtpicker);
    this.loading = true;
    const payload = JSON.parse(
      JSON.stringify({
        pos_id: this.item.value,
        start_date: this.dtpicker.start,
        end_date: this.dtpicker.end,
      })
    );
    const results = await getAnalyticsAvg(payload, this.selectedYearOver);
    // const results = await getAnalytics(payload, this.selectedYearOver);
    if (results && results.length > 0) {
      const result_cur = results;
     
      let dates = result_cur.map((item) => item.date);
      // Filter dates
      dates = dates.filter((v, i, a) => a.indexOf(v) === i);
      let series_current = setupHeatmapSeries(results, metrics, baselines);
      let new_series = [];
      for (let i = 0; i < series_current.length; i++) {
        let item = series_current[i];

        let item0_cur = item.data[0].y;
        item0_cur = isNaN(item0_cur) ? 0 : item0_cur;
        let item0 = item0_cur;
     
        let item1_cur = item.data[1].y;
        item1_cur = isNaN(item1_cur) ? 0 : item1_cur;
        let item1 = item1_cur;

        let item2 = item0 - item1;

        let item3_cur = item.data[3].y;
        item3_cur = isNaN(item3_cur) ? 0 : item3_cur;
        let item3 = item3_cur;

        let item4 = item0 - item3;

        let item5_cur = item.data[5].y;
        item5_cur = isNaN(item5_cur) ? 0 : item5_cur;
        let item5 = item5_cur;

        let item6 = item0 - item5;
        // console.log("item0", item0);
        item0 = item0 ? item0 : 0;
        item1 = item1 ? item1 : 0;
        item2 = item2 ? item2 : 0;
        item3 = item3 ? item3 : 0;
        item4 = item4 ? item4 : 0;
        item5 = item5 ? item5 : 0;
        item6 = item6 ? item6 : 0;

        item.data[0].y = roundOff2(item0);
        item.data[1].y = roundOff2(item1);
        item.data[2].y = roundOff2(item2);
        item.data[3].y = roundOff2(item3);
        item.data[4].y = roundOff2(item4);
        item.data[5].y = roundOff2(item5);
        item.data[6].y = roundOff2(item6);
        new_series.push({
          name: item.name,
          data: item.data,
        });
      }
      this.series = new_series.reverse();
      console.log("this.series", this.series);
    }
    this.loading = false;
  },
};
</script>
<template>
  <v-card elevation="1">
    <v-card-title class="pb-0">{{ item.name }}</v-card-title>
    <v-card-text class="pt-0">{{ item.full_address }}</v-card-text>
    <div v-if="loading">Loading...</div>
    <div class="text-center p-5" v-if="!loading && series.length === 0">
      No data to be shown
    </div>
    <apexchart
      type="heatmap"
      height="350"
      :options="chartOptions"
      :series="series"
      v-if="!loading && series.length > 0"
    ></apexchart>
  </v-card>
</template>